module.exports = __webpack_public_path__ + "static/media/clipboard.f0a74e53.svg";